var whatsappRelativePath = '/whatsapp';
var settingsWhatsappRelativePath = '/settings/whatsapp';
export var createWhatsappApi = function (baseUrl, http) {
    var whatsappApiUrl = baseUrl + whatsappRelativePath;
    var whatsappTemplatesApiUrl = baseUrl + settingsWhatsappRelativePath;
    return {
        addAgentReply: function (whatsappDto) { return http.post(whatsappApiUrl + "/message", whatsappDto); },
        getTemplates: function (dto) {
            return http.get(whatsappTemplatesApiUrl + "/templates?locale=" + dto.locale);
        },
    };
};
//# sourceMappingURL=index.js.map